import { Component, OnInit, ViewChild } from '@angular/core';
import { Admis } from 'src/app/model/Admis';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';
import { AppelsService } from '../../service/appels.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-nonadmis',
  templateUrl: './nonadmis.component.html',
  styleUrls: ['./nonadmis.component.css'],
})
export class NonadmisComponent implements OnInit {
  AllAdmis: Admis[] = [];
  AllAdmisGender: any[] = [];
  IAhomme!: number;
  IAfemme!: number;
  DEVhomme!: number;
  DEVfemme!: number;
  TECHhomme!: number;
  TECHfemme!: number;
  EBUShomme!: number;
  EBUSfemme!: number;
  totalHomme: number = 0;
  totalFemme: number = 0;
  cohorte: any = null;

  showDetails: boolean = false;
  ligneDetails!: Admis;

  displayedColumns: string[] = [
    'iuf',
    'prenom',
    'nom',
    'age',
    'mail',
    'actions',
  ];
  dataSource = new MatTableDataSource<Admis>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(private appelsService: AppelsService) {}
  ngOnInit(): void {
    this.getlistNonAdmis();
    this.getListAdmisByGender();
    this.cohorte = sessionStorage.getItem('cohorte');

    // this.appelsService.notifierNonAdmission().subscribe((response) => {
    //   // //console.log('email non admis send', response);
    // });

    this.breadcrumbItems = [
      { label: 'SIGUI'},
      { label: `SESSION ${this.cohorte}`, url: `/dashboard/appels/candidatures/${this.cohorte}`},
      { label: 'NON-ADMIS', url: `/dashboard/appels/nonadmis/${this.cohorte}`},
    ];
  }

  getlistNonAdmis(): void {
    /*  this.appelsService.getListNoAdmis().subscribe(
      (list:Admis[])=>{
      this.AllAdmis =list.splice(0,10);
      //// //console.log(this.AllAdmis);
    },
    ); */

    this.appelsService
      .getListNoAdmis()
      .pipe()
      .subscribe({
        next: (list: Admis[]) => {
          // //console.log('les non-admis: ', list);
          this.dataSource.data = list;
          this.dataSource.paginator = this.paginator;
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
  }

  getListAdmisByGender(): void {
    this.appelsService.getNoAdmisBySexe().subscribe((data: any) => {
      //// //console.log((data));

      data['DÉVELOPPEMENT LOGICIEL']?.Homme;
      data['DÉVELOPPEMENT LOGICIEL']?.Femme;
      this.DEVhomme = data['DÉVELOPPEMENT LOGICIEL']?.Homme;
      this.DEVfemme = data['DÉVELOPPEMENT LOGICIEL']?.Femme;

      this.IAhomme = data['INTELLIGENCE ARTIFICIELLE ET DATA']?.Homme;
      this.IAfemme = data['INTELLIGENCE ARTIFICIELLE ET DATA']?.Femme;

      this.TECHhomme = data['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.Homme;
      this.TECHfemme = data['TECHNOLOGIES EMERGENTES ET CYBERSECURITE']?.Femme;

      this.EBUShomme = data['e-BUSINESS']?.Homme;
      this.EBUSfemme = data['e-BUSINESS']?.Homme;

      this.totalHomme =
        this.DEVhomme + this.IAhomme + this.TECHhomme + this.EBUShomme;
      this.totalFemme =
        this.DEVfemme + this.IAfemme + this.TECHfemme + this.EBUSfemme;
    });
  }

  exportPDF(): void {
    this.appelsService.exportToPDFNonAdmis().subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url); // Ovr nvll fenêtre
      },
      (error) => {
        console.error('Error exporting PDF:', error);
      }
    );
  }

  exportAdmisExcel() {
    this.appelsService.exportAdmisExcelNonAdmis().subscribe((data) => {
      const blob = new Blob([data], {
        type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const donnees = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = donnees;
      link.download = 'Nonadmis.xlsx';
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(function () {
        window.URL.revokeObjectURL(donnees);
        link.remove();
      }, 100);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleModalDetails(row: Admis) {
    // //console.log('les donnees de la personne sont: ', row);
    this.ligneDetails = row;
    this.showDetails = true;
  }

  closeModalDetails() {
    this.showDetails = false;
  }
}
